import { Trophy } from 'lucide-react'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import useGroupBracketRemoval from '../hooks/useGroupBracketRemoval'
import { groupBracketsByTournament } from '../lib/groupTournaments'
import GroupTournamentCard from './GroupTournamentCard'
import { Button } from './ui/button'

// The group page's main view: one card per tournament, each with the
// Brackets / Leaderboard / Prizes tabs players know from Home, narrowed to
// the group. The most relevant tournament opens expanded.
export default function GroupTournamentsTab({ brackets, groupId, isOwner = false, onChanged }) {
  const navigate = useNavigate()
  const tournaments = useMemo(() => groupBracketsByTournament(brackets), [brackets])
  const { removeTournament } = useGroupBracketRemoval(groupId, onChanged)

  if (tournaments.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <Trophy className="h-12 w-12 mx-auto mb-4 opacity-50" />
        <p>No tournaments yet</p>
        <p className="text-sm mt-1">
          {isOwner
            ? 'Every bracket you enter is added to your group automatically.'
            : 'Tournaments show up here when the group owner enters them.'}
        </p>
        <Button onClick={() => navigate('/tournaments')} className="mt-4">
          Browse Tournaments
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {tournaments.map((t, i) => (
        <GroupTournamentCard
          key={t.id}
          tournament={t}
          groupId={groupId}
          defaultExpanded={i === 0}
          isOwner={isOwner}
          onRemove={(tournament) => removeTournament({ tournamentId: tournament.id, name: tournament.name })}
        />
      ))}
    </div>
  )
}
